module.exports = __webpack_public_path__ + "img/Tutorial_Part1_NoVideo.0c7620e9.png";